import _objectWithoutProperties from "/drone/src/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import { useComponentTheme } from '../../../../../utils/hooks';
import { HeaderNavigationMenuContentBodyRoot } from './style';
import { HeaderNavigationMenuContentBodyOptions } from '../HeaderNavigationMenuContentBodyOptions';
import { useHeaderNavigationMenuContentBodyClassName } from './utils';
import { HEADER_NAVIGATION_MENU_CONTENT_BODY_CLASS_PREFIX, headerNavigationMenuContentBodyRoot } from './constants';
import { headerNavigationMenuContentBodyTheme } from './theme';
export var HeaderNavigationMenuContentBody = function HeaderNavigationMenuContentBody(_ref) {
  var className = _ref.className,
      options = _ref.options,
      selectedValue = _ref.selectedValue,
      onOptionSelect = _ref.onOptionSelect,
      restProps = _objectWithoutProperties(_ref, ["className", "options", "selectedValue", "onOptionSelect"]);

  var theme = useComponentTheme(HEADER_NAVIGATION_MENU_CONTENT_BODY_CLASS_PREFIX, headerNavigationMenuContentBodyTheme);
  var classOverride = useHeaderNavigationMenuContentBodyClassName(HEADER_NAVIGATION_MENU_CONTENT_BODY_CLASS_PREFIX, className);
  return React.createElement(HeaderNavigationMenuContentBodyRoot, Object.assign({
    "data-testid": headerNavigationMenuContentBodyRoot
  }, restProps, {
    theme: theme,
    className: classOverride.Root
  }), options ? React.createElement(HeaderNavigationMenuContentBodyOptions, {
    options: options,
    selectedValue: selectedValue,
    onOptionSelect: onOptionSelect
  }) : null);
};
HeaderNavigationMenuContentBody.defaultProps = {};